import React from 'react';
import { useActivityCount } from '@tokenized/sdk-react-private';
import classNames from 'classnames';
import styles from './ActivityIndicator.scss';
import { pendingFilter } from './ActivityTable.js';

export default function ActivityIndicator({
  profileId,
  className,
  children,
  useActivityHook = null,
}) {
  if (useActivityHook === null) {
    useActivityHook = useActivityCount;
  }

  const openCount =
    useActivityHook({
      profileId,
      overviewFilter: pendingFilter,
      filters: {
        includeSuccessfulEvents: false,
        includeFailedEvents: false,
        includeEventsRequiringAction: true,
        includeEventsPendingOthers: false,
      },
    }) || 0;

  const hasActivity = !!openCount;

  return hasActivity
    ? children || (
        <svg
          viewBox="0 0 8 8"
          fill="none"
          className={classNames(styles.activityIndicator, className)}
        >
          <circle cx="4" cy="4" r="4" fill="#FC5F67" />
        </svg>
      )
    : null;
}
